import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { T2TemplateBasicComponent } from 'app/trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { SkillsComponent } from './components/skills/skills.component';
import {AutoroutingJobsComponent} from './components/autorouting-jobs/autorouting-jobs.component';

const routes: Routes = [
  {path: 'pages', component: T2TemplateBasicComponent,
  children: [
    {path: 'administration/dispatch', children: [
      {path: 'skills', component: SkillsComponent, data: {title: 'Skills'}}
    ]},
    {path: 'administration/dispatch', children: [
      {path: 'jobs', component: AutoroutingJobsComponent, data: {title: 'Autorouting Jobs'}}
    ]}
  ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AutoroutingRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/autorouting/autorouting-routing.module.ts